// src/translate/track-rendering/index.ts
var rendering = 0;
function begin() {
  rendering++;
}
function end() {
  rendering--;
}
function isRendering() {
  return rendering > 0;
}

export {
  begin,
  end,
  isRendering
};
